var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.666 5.109h-3V1.514c0-.257-.25-.514-.5-.514h-1c-.313 0-.5.257-.5.514v3.595h-12V1.514c0-.257-.25-.514-.5-.514h-1c-.312 0-.5.257-.5.514v3.595h-3c-1.687 0-3 1.412-3 3.081v22.598c0 1.733 1.313 3.082 3 3.082h22c1.625 0 3-1.349 3-3.082V8.19c0-1.669-1.375-3.081-3-3.081zm1 25.679c0 .578-.5 1.027-1 1.027h-22c-.562 0-1-.45-1-1.027V13.326h24v17.462zm0-19.516h-24V8.19c0-.513.438-1.027 1-1.027h22c.5 0 1 .514 1 1.027v3.082zm-19 14.38h6c.5 0 1-.45 1-1.027v-6.163c0-.514-.5-1.027-1-1.027h-6c-.562 0-1 .513-1 1.027v6.163c0 .578.438 1.027 1 1.027zm1-6.163h4v4.109h-4v-4.109z",
    fill: "#02555B",
    stroke: "#02555B",
    strokeWidth: 0.2
  })));
}
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL2Nzcy8zM2Y3MmZkZmZkMzlhZjdhMDEyZGIxZjMzZmRjMzQ4YS5zdmciOw==";
export { SvgCalendar as ReactComponent };